import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useAppSelector } from 'store';
import { selectUser } from 'store/selectors/me/user';
import config from 'utils/config';
import { SENTRY_REPLAY_UNBLOCK, SENTRY_REPLAY_UNMASK } from 'utils/sentry';

if (config.sentry.dsn)
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.env,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        unmask: SENTRY_REPLAY_UNMASK,
        unblock: SENTRY_REPLAY_UNBLOCK,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 1.0,
    // Known third-party noise: browser extensions and blocked analytics beacons, not app errors
    ignoreErrors: ['Object Not Found Matching Id', 'ResizeObserver loop limit exceeded'],
    denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i],
  });

const useInitSentry = () => {
  const user = useAppSelector(selectUser);

  // If the user has loaded update Sentry with their info
  useEffect(() => {
    if (!user) return;

    if (user.flags?.stayAnonymous !== true) {
      Sentry.setUser({
        id: user._id,
      });
    }
  }, [user]);
};

export default useInitSentry;
